import { inject } from '@angular/core';
import { type HttpInterceptorFn } from '@angular/common/http';
import { TmaService } from '../services/tma.service';
import { environment } from '../../../environments/environment';

export const tmaAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const tmaService = inject(TmaService);

  if (req.url.startsWith(environment.apiUrl)) {
    const initData = tmaService.initData();
    if (initData) {
      const authReq = req.clone({
        setHeaders: { Authorization: `tma ${initData}` },
      });
      return next(authReq);
    }
  }

  return next(req);
};
